// Inventory items grouped by category (based on Yescapa rental contract)
export const INVENTORY_GROUPS = [
  {
    id: "seguridad",
    label: "Seguridad",
    items: [
      { id: "extintor", label: "Extintor" },
      { id: "kit_seguridad", label: "Chaleco + triángulo" },
      { id: "calzas", label: "Juego de calzas" },
      { id: "cadenas_nieve", label: "Cadenas de nieve" },
    ],
  },
  {
    id: "cocina",
    label: "Cocina",
    items: [
      { id: "vajilla", label: "Kit de vajilla" },
      { id: "bateria_cocina", label: "Batería de cocina" },
      { id: "cafetera", label: "Cafetera" },
      { id: "barbacoa", label: "Barbacoa" },
    ],
  },
  {
    id: "exterior",
    label: "Exterior",
    items: [
      { id: "mesa_exterior", label: "Mesa de exterior" },
      { id: "sillas_exterior", label: "Sillas de exterior (4)" },
      { id: "ducha_exterior", label: "Ducha exterior" },
      { id: "portabicicletas", label: "Portabicicletas" },
      { id: "toldo", label: "Toldo lateral" },
    ],
  },
  {
    id: "interior",
    label: "Interior y descanso",
    items: [
      { id: "ropa_cama", label: "Ropa de cama" },
      { id: "wc_portatil", label: "WC portátil" },
      { id: "kit_limpieza", label: "Kit de limpieza" },
    ],
  },
  {
    id: "tecnologia",
    label: "Tecnología",
    items: [
      { id: "gps", label: "GPS" },
      { id: "tv", label: "TV" },
      { id: "antena", label: "Antena parabólica" },
      { id: "camara_marcha_atras", label: "Cámara marcha atrás" },
      { id: "radar_marcha_atras", label: "Radar marcha atrás" },
    ],
  },
];

export const ALL_INVENTORY_ITEMS = INVENTORY_GROUPS.flatMap((g) =>
  g.items.map((i) => ({ ...i, group: g.label })),
);

export function defaultInventoryState() {
  const out = {};
  ALL_INVENTORY_ITEMS.forEach((i) => (out[i.id] = true));
  return out;
}

export const FUEL_LEVELS = ["0", "1/4", "1/2", "3/4", "1"];
